"use client";

import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AllLead = () => {
  const [leads, setLeads] = useState([]);
  const [leadStatusList, setLeadStatusList] = useState([]); // ✅ NEW
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [selectedLeadStatus, setSelectedLeadStatus] = useState("");


  // 🔹 COMMENT STATES
  const [isAddCommentOpen, setIsAddCommentOpen] = useState(false);
  const [isViewCommentOpen, setIsViewCommentOpen] = useState(false);
  // const [selectedLeadId, setSelectedLeadId] = useState(null);
  const [selectedLead, setSelectedLead] = useState(null);

  const [commentText, setCommentText] = useState("");
  const [comments, setComments] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    fetchLeads();
    fetchLeadStatusList(); // ✅ NEW
  }, []);

  const fetchLeads = async () => {
    try {
      setIsLoading(true);
      const res = await axios.get(
        "https://logicx.premierlam.com/api/get_pixel-all-leads-data",
        { headers: { authorization: localStorage.getItem("accessToken") } }
      );
      setLeads(res.data.data || []);
    } catch {
      toast.error("Failed to fetch leads");
    } finally {
      setIsLoading(false);
    }
  };

  // ✅ FETCH LEAD STATUS LIST
  const fetchLeadStatusList = async () => {
    try {
      const res = await axios.get(
        "https://logicx.premierlam.com/api/get-pixel-lead-status",
        { headers: { authorization: localStorage.getItem("accessToken") } }
      );
      setLeadStatusList(res.data.data || []);
    } catch {
      toast.error("Failed to load lead status list");
    }
  };

  // ✅ UPDATE LEAD STATUS
  const handleLeadStatusUpdate = async (leadId, newStatus) => {
    try {
      await axios.put(
        `https://logicx.premierlam.com/api/update-lead-status/${leadId}`,
        { lead_status: newStatus },
        {
          headers: {
            authorization: localStorage.getItem("accessToken"),
            "Content-Type": "application/json",
          },
        }
      );

      // update UI instantly
      setLeads((prev) =>
        prev.map((l) =>
          l.id === leadId ? { ...l, lead_status: newStatus } : l
        )
      );

      toast.success("Lead status updated", { autoClose: 2000 });
    } catch {
      toast.error("Failed to update lead status");
    }
  };

  /* ===================== COMMENTS ===================== */

  // const openAddComment = (leadId) => {
  //   setSelectedLeadId(leadId);
  //   setCommentText("");
  //   setIsAddCommentOpen(true);
  // };
  const openAddComment = (lead) => {
  setSelectedLead(lead);
  setCommentText("");
  setIsAddCommentOpen(true);
};


  const openViewComments = async (leadId) => {
    try {
     setSelectedLead(leads.find(l => l.id === leadId));

      const res = await axios.get(
        `https://logicx.premierlam.com/api/get-pixel-leads-comments/${leadId}`,
        { headers: { authorization: localStorage.getItem("accessToken") } }
      );
      setComments(res.data.data || []);
      setIsViewCommentOpen(true);
    } catch {
      toast.error("Failed to fetch comments");
    }
  };

  const handleAddComment = async (e) => {
    e.preventDefault();
    if (!commentText.trim()) return toast.error("Comment cannot be empty");

    try {
      setIsSubmitting(true);
      await axios.post(
  "https://logicx.premierlam.com/api/add-pixel-leads-comments",
  {
    lead_id: selectedLead.id,
    lead_comment: commentText,
    lead_name: selectedLead.customer_name,
    lead_phone_number: selectedLead.customer_phone,
  },
  {
    headers: {
      authorization: localStorage.getItem("accessToken"),
      "Content-Type": "application/json",
    },
  }
);

      toast.success("Comment added");
      setIsAddCommentOpen(false);
      setCommentText("");
    } catch {
      toast.error("Failed to add comment");
    } finally {
      setIsSubmitting(false);
    }
  };

  /* ===================== HELPERS ===================== */

  const filteredLeads = leads.filter((l) => {
    const matchesSearch =
      [
        l.lead_type,
        l.customer_name,
        l.customer_email,
        l.customer_phone,
        l.customer_state,
        l.customer_requirements,
        l.lead_status,
        l.added_by,
      ]
        .join(" ")
        .toLowerCase()
        .includes(searchTerm.toLowerCase());

    const matchesStatus =
      !selectedLeadStatus || l.lead_status === selectedLeadStatus;

    return matchesSearch && matchesStatus;
  });

  const formatDate = (date) =>
    new Date(date).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

  // ✅ ROW COLOR BASED ON STATUS
  const getRowColor = (status) => {
    const colors = {
      Pending: "#fde2e2",
      "Follow up": "#fce7f3",
      "Hot Lead": "#fef9c3",
      "Lost Lead": "#e0f2fe",
      "Converted Lead": "#dcfce7",
      "Not Interested": "#f3f4f6",
    };
    return colors[status] || "white";
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />

      <div className="min-h-screen bg-gray-50 p-2">
        <div className="max-w-7xl mx-auto">

          {/* HEADER */}
          <div className="flex justify-between items-start mb-6">
            <div>
              <h1 className="text-2xl font-semibold text-gray-900 mb-1">Leads</h1>
              <p className="text-gray-500">All customer leads</p>
            </div>

            <Link
              to="/add-lead"
              className="bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded-lg"
            >
              + Add Lead
            </Link>
          </div>

          {/* TABLE */}
          <div className="bg-white rounded-lg shadow-sm border p-6">
            {/* <input
              type="text"
              placeholder="Search leads..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="mb-4 px-4 py-2 border rounded-lg w-64"
            /> */}
            <div className="flex gap-4 mb-4 justify-between">
              {/* SEARCH */}
              <input
                type="text"
                placeholder="Search leads..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="px-4 py-2 border rounded-lg w-64"
              />

              {/* LEAD STATUS FILTER */}
              <select
                value={selectedLeadStatus}
                onChange={(e) => setSelectedLeadStatus(e.target.value)}
                className="px-4 py-2 border rounded-lg w-56 bg-white"
              >
                <option value="">All Lead Status</option>
                {leadStatusList.map((s) => (
                  <option key={s.id} value={s.lead_status}>
                    {s.lead_status}
                  </option>
                ))}
              </select>
            </div>


            <div className="overflow-x-auto">
              {isLoading ? (
                <div className="text-center py-6">Loading...</div>
              ) : (
                <table className="w-full text-sm">
                  <thead>
                    <tr className="border-b text-gray-600 whitespace-nowrap">
                      <th className="py-3 px-4 text-left">Lead Type</th>
                      <th className="py-3 px-4 text-left">Customer Name</th>
                      <th className="py-3 px-4 text-left">Email</th>
                      <th className="py-3 px-4 text-left">Phone</th>
                      <th className="py-3 px-4 text-left">State</th>
                      <th className="py-3 px-4 text-left">Looking For</th>
                      
                      <th className="py-3 px-4 text-left">Requirements</th>
                      <th className="py-3 px-4 text-left">Lead Status</th>
                      <th className="py-3 px-4 text-left">Created At</th>
                      <th className="py-3 px-4 text-left">Added By</th>
                      <th className="py-3 px-4 text-left">Lead Comments</th>
                    </tr>
                  </thead>

                  <tbody>
                    {filteredLeads.map((l) => (
                      <tr
                        key={l.id}
                        className="border-b"
                        style={{ backgroundColor: getRowColor(l.lead_status) }}
                      >
                        <td className="py-3 px-4">{l.lead_type}</td>
                        <td className="py-3 px-4">{l.customer_name}</td>
                        <td className="py-3 px-4">{l.customer_email}</td>
                        <td className="py-3 px-4">{l.customer_phone}</td>
                        <td className="py-3 px-4">{l.customer_state}</td>
                        <td className="py-3 px-4">{l.looking_for}</td>
                        <td className="py-3 px-4">{l.customer_requirements}</td>

                        {/* ✅ STATUS DROPDOWN */}
                        <td className="py-3 px-4">
                          <select
                            value={l.lead_status || ""}
                            onChange={(e) =>
                              handleLeadStatusUpdate(l.id, e.target.value)
                            }
                            className="border rounded px-2 py-1 bg-white"
                          >
                            <option value="">Select</option>
                            {leadStatusList.map((s) => (
                              <option key={s.id} value={s.lead_status}>
                                {s.lead_status}
                              </option>
                            ))}
                          </select>
                        </td>

                        <td className="py-3 px-4">{formatDate(l.created_at)}</td>
                        <td className="py-3 px-4">{l.added_by}</td>

                        <td className="py-3 px-4">
                          <div className="flex gap-2">
                            <button
                              onClick={() => openAddComment(l)}
                              className="px-3 py-1 text-xs bg-green-500 text-white rounded"
                            >
                              Add
                            </button>
                            <button
                              onClick={() => openViewComments(l.id)}
                              className="px-3 py-1 text-xs bg-blue-500 text-white rounded"
                            >
                              View
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* ADD / VIEW COMMENT MODALS — UNCHANGED */}
      {/* (kept exactly as you already have) */}
      {/* ================= ADD COMMENT MODAL ================= */}
      {isAddCommentOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
          <div className="bg-white rounded-lg p-6 w-full max-w-md">
            <h2 className="text-lg font-semibold mb-4">Add Comment</h2>

            <form onSubmit={handleAddComment} className="space-y-4">
              <textarea
                rows="4"
                placeholder="Enter comment..."
                value={commentText}
                onChange={(e) => setCommentText(e.target.value)}
                className="w-full border rounded px-3 py-2"
                required
              />

              <div className="flex justify-end gap-3">
                <button
                  type="button"
                  onClick={() => setIsAddCommentOpen(false)}
                  className="px-4 py-2 bg-gray-100 rounded"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="px-4 py-2 bg-orange-500 text-white rounded"
                >
                  {isSubmitting ? "Adding..." : "Add"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* ================= VIEW COMMENT MODAL ================= */}
      {isViewCommentOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
          <div className="bg-white rounded-lg p-6 w-full max-w-lg">
            <h2 className="text-lg font-semibold mb-4">Lead Comments</h2>

            <div className="space-y-3 max-h-80 overflow-y-auto">
              {comments.length === 0 ? (
                <p className="text-gray-500">No comments found</p>
              ) : (
                comments.map((c) => (
                  <div key={c.id} className="border rounded p-3">
                    <div className="text-xs text-gray-500 mb-1">
                      Comment #{c.comment_number} • {formatDate(c.created_at)}
                    </div>
                    <div className="text-sm">{c.lead_comment}</div>
                  </div>
                ))
              )}
            </div>

            <div className="flex justify-end pt-4">
              <button
                onClick={() => setIsViewCommentOpen(false)}
                className="px-4 py-2 bg-gray-100 rounded"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

    </>
  );
};

export default AllLead;
